require('./module/ua');

(function($){

  var mq_m = window.matchMedia('(max-width:768px)').matches;

  // vars
  var animating = false,
      transitionSpeed = 1000,
      speed = 700;
  
  var centerPoints = "",
      largePoints = "";

  // DOM
  var $section = $('.section'),
      $currentSection = $('.section').filter('.current'),
      $prevSection = null;
  
  // function
  function resize(){
    
    // re init
    mq_m = window.matchMedia('(max-width:768px)').matches;

    _calcClipPath();
    if( mq_m ){
      _elementPos();
    }

    function _calcClipPath(){
      
      var viewBoxW = 1200,
          viewBoxH = 700;

      var toPath = [
        [.5,-5.626142857],
        [1.387,-.946142857],
        [4.2575,-.946142857],
        [1.93525,1.946142857],
        [2.82225,6.626142857],
        [.5,3.733714286],
        [-1.82225,6.626142857],
        [-.93525,1.946142857],
        [-3.2575,-.946142857],
        [-.387,-.946142857]
      ];

      var adjustX = null,
          adjustY = null;
      
      if( !mq_m ){
        adjustX = (window.innerWidth - viewBoxW) / 2;
        adjustY = (window.innerHeight - viewBoxH) / 2;
      }
      else {
        adjustX = ($section.width() - viewBoxW) / 2 + $section.offset().left;
        adjustY = ($section.height() - viewBoxH) / 2 + $section.offset().top;
      }

      largePoints = "";
      for(var i=0; i<toPath.length; i++){
        var x = toPath[i][0] * viewBoxW + adjustX;
        var y = toPath[i][1] * viewBoxH + adjustY;

        largePoints += ""+x+","+y+" ";
      }
      largePoints = largePoints.slice(0,-1)

      centerPoints = "";
      for(var i=0; i<toPath.length; i++){
        if( !mq_m ){
          var x = $section.width() / 2;
          var y = $section.height() / 2;
        }
        else {
          var x = $section.width() / 2;
          var y = $section.height() / 2;
          // var x = $(window).innerWidth() / 2;
          // var y = $(window).innerHeight() / 2;
        }

        centerPoints += ""+x+","+y+" ";
      }
      centerPoints = centerPoints.slice(0,-1);

      adjustDefault();

    }


    function _elementPos(){
      var sectionH = $('.sections').height();
      var $nav = $('.bar--right');
      var $header = $('.bar--top');
      var $page = $('.pages');

      $page.css({
        height: window.innerHeight
      });

      var top = ( window.innerHeight + parseInt(sectionH) ) / 2 + 15;
      $nav.css({
        top: top
      });

      $header.css({
        height: (window.innerHeight - sectionH) / 2
      })
    }

  } //resize


  // page transition
  function nextSection(index){
    if( $section.eq(index).length !== 0 ){
      switchSection(index);
    }
  } //nextSection


  function prevSection(index){
    if( $section.eq(index).length !== 0 ){
      switchSection(index);
    }
  } //prevSection


  function switchSection(index){
    var targetIndex = index;
    var currentIndex = $currentSection.index();

    var dir = targetIndex > currentIndex ? 'next' : 'prev';
    var $targetSection = $section.eq(targetIndex);

    pageIndex = targetIndex;
    animating = true;
    
    switchBtn( targetIndex );

    if( dir === 'next' ){

      $currentSection
        .addClass('leaving')
        .removeClass('current');
      
      $targetSection.addClass('current');
      var $star = Snap('.current .star');

      $star.animate({
        points: largePoints
      }, speed, mina.easeinout, function(){
        $currentSection.removeClass('leaving');
        $currentSection = $targetSection;

        animating = false;

        adjustDefault();
      });

    }
    else if( dir === 'prev' ){

      var $star = Snap('.current .star');
      $targetSection.addClass('leaving');

      $star.animate({
        points: centerPoints
      }, speed, mina.easeinout, function(){
        $currentSection.removeClass('current');
        $targetSection.removeClass('leaving').addClass('current');
        $currentSection = $targetSection;

        animating = false;

        adjustDefault();
      });

    }

  }


  function adjustDefault(){
    $currentSection.removeClass('nextall prevall');
    $currentSection.prevAll().addClass('prevall').removeClass('nextall');
    $currentSection.nextAll().addClass('nextall').removeClass('prevall');
    
    var pStars = [].slice.call(document.querySelectorAll('.prevall .star'));
    pStars.forEach(function(star){
      var pStar = Snap(star);
      pStar.attr('points', largePoints);
    });

    var nStars = [].slice.call(document.querySelectorAll('.nextall .star'));
    nStars.forEach(function(star){
      var nStar = Snap(star);
      nStar.attr('points', centerPoints);
    });
  }

  
  function switchBtn(index){
    var $nav = $('.nav');
    var $navBtn = $('button', $nav);

    $navBtn.removeClass('current');
    $navBtn.eq(index).addClass('current')
  }

  function clickBtn(index){
    switchBtn(index);

    if( !myua.ie ){
      switchSection(index);
    }
    else {

      $('html, body').animate({
        scrollTop: $('.section').eq(index).offset().top
      }, 600);

    }
  }


  function goNext(){
    var i = $('.current').index();
    if( i <= $section.length ){
      i++;
      nextSection(i);
    }
  }


  function goPrev(){
    var i = $('.current').index();
    if( i > 0 ){
      i--;
      prevSection(i);
    }
  }


  $(function(){

    // init
    init();
    function init(){
      resize();
      _settingNav();

      $('img.lazy').lazyload({});

      for( var key in myua ){
        if( myua.hasOwnProperty(key) ){
          if( myua[key] ){
            $('body').addClass('browser--'+key);
          }
        }
      }

      var $star = Snap('.current .star');
      $star.attr('points', centerPoints);
      $star.animate({
        points: largePoints
      }, speed, mina.easeinout);

      $currentSection.nextAll().addClass('nextall');

      function _settingNav(){
        var $nav = $('.nav');
        $('.section').each(function(){
          var $navBtn = $('.nav button').first().clone().appendTo($nav);
        });
        $('.nav button').first().remove();
        $('.nav button').eq(0).addClass('current');

        $('.nav button').on('click', function(){
          var index = $(this).index();
          if( !animating && !$(this).hasClass('current') ){
            clickBtn(index);
          }
        });
      }

    }

    // イベントを制御
    if( !mq_m ){
      
      // IE以外ではmousewheelで発火
      if( !myua.ie ){
        $(window).on('DOMMouseScroll mousewheel', function(event){
          if( !animating ){
            if( event.deltaY < -15 ){
              goNext();
            }

            if( event.deltaY > 15 ) {
              goPrev();
            }
          }
    
          return false;
        });
      }
      else {
        
        // IEでは純粋なスクロールイベント
        _scroll();
        $(window).on('scroll', function(){
          _scroll();
        });

        function _scroll(){
          var scrollTop = $(this).scrollTop();

          $('.section').each(function(){
            var $this = $(this);
            var pos = $this.offset().top;
            var index = $this.index();

            if( scrollTop > pos - window.innerHeight * 2/5 ){
              switchBtn(index);
              $this.addClass('animation--play');

              setTimeout(function(){
                $this.addClass('animation--end');
              }, 600);
            }
          });
        }
      }
      
    }
    else {
      $('#Main').hammer().on('swipeleft swipedown', function(){
        if( !animating ){
          goNext();
        }
      });
      $('#Main').hammer().on('swiperight swipeup', function(){
        if( !animating ){
          goPrev();
        }
      });
    }

    $(window).on('resize', resize);

  });


})(jQuery);